export let MergeUnitsListOrigin;
(function(MergeUnitsListOrigin2) {
  MergeUnitsListOrigin2[MergeUnitsListOrigin2["SRC"] = 0] = "SRC";
  MergeUnitsListOrigin2[MergeUnitsListOrigin2["DST"] = 1] = "DST";
})(MergeUnitsListOrigin || (MergeUnitsListOrigin = {}));
